import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Select,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CARD_HELP_TEXT, CardHeadingWithHelp } from "../shared/help";

const BankSection = ({
  bankTransfers,
  bankEdits,
  setBankEdits,
  canFinance,
  handleBankPreview,
  handleBankTransferUpdate,
  bankPreview,
  meta,
  formatPayrollCurrency,
}) => (
  <Stack spacing={6}>
    <Card>
      <CardHeader>
        <CardHeadingWithHelp title="Bank Transfers" helpText={CARD_HELP_TEXT.bankTransfers} />
      </CardHeader>
      <CardBody>
        <TableContainer>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Run</Th>
                <Th>Total Amount</Th>
                <Th>Status</Th>
                <Th>Preview</Th>
                <Th>Update</Th>
              </Tr>
            </Thead>
            <Tbody>
              {bankTransfers.map((transfer) => {
                const draft = bankEdits[transfer._id] || {};
                return (
                  <Tr key={transfer._id}>
                    <Td>{`${transfer.payrollRunId?.month || "-"}/${transfer.payrollRunId?.year || "-"}`}</Td>
                    <Td>{formatPayrollCurrency(transfer.totalAmount, meta)}</Td>
                    <Td>
                      {canFinance ? (
                        <Select
                          size="xs"
                          value={draft.status || transfer.status}
                          onChange={(e) =>
                            setBankEdits((prev) => ({
                              ...prev,
                              [transfer._id]: {
                                ...prev[transfer._id],
                                status: e.target.value,
                              },
                            }))
                          }
                        >
                          <option value="GENERATED">GENERATED</option>
                          <option value="UPLOADED">UPLOADED</option>
                          <option value="PROCESSED">PROCESSED</option>
                        </Select>
                      ) : (
                        <Badge>{transfer.status}</Badge>
                      )}
                    </Td>
                    <Td>
                      <Button
                        size="xs"
                        onClick={() => handleBankPreview(transfer.payrollRunId?._id)}
                      >
                        View
                      </Button>
                    </Td>
                    <Td>
                      {canFinance ? (
                        <Button
                          size="xs"
                          onClick={() => handleBankTransferUpdate(transfer._id)}
                        >
                          Save
                        </Button>
                      ) : null}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </CardBody>
    </Card>

    {bankPreview ? (
      <Card>
        <CardHeader>
          <CardHeadingWithHelp title="Bank Preview" helpText={CARD_HELP_TEXT.bankPreview} />
        </CardHeader>
        <CardBody>
          <Text mb={3}>
            Transfer Total: {formatPayrollCurrency(bankPreview.transfer?.totalAmount || 0, meta)}
          </Text>
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Employee</Th>
                  <Th>Employee ID</Th>
                  <Th>Net Pay</Th>
                  <Th>Account</Th>
                  <Th>IFSC</Th>
                </Tr>
              </Thead>
              <Tbody>
                {(bankPreview.rows || []).map((row) => (
                  <Tr key={`${row.userId}-${row.employeeId}`}>
                    <Td>{row.employeeName}</Td>
                    <Td>{row.employeeId || "-"}</Td>
                    <Td>{formatPayrollCurrency(row.netPay, meta)}</Td>
                    <Td>{row.bankDetails?.accountNumber || "-"}</Td>
                    <Td>{row.bankDetails?.ifscCode || "-"}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    ) : null}
  </Stack>
);

export default BankSection;
